export { default as AppsIcon } from './AppsIcon'


// WEBPACK FOOTER //
// ../../src/AppsIcon/index.js